import React, { useState } from 'react';
import { Menu, X, Phone, Mail, MapPin, Download, AlertCircle } from 'lucide-react';
import { Button } from './ui/Button';
interface LayoutProps {
  children: React.ReactNode;
  currentPage: string;
  onNavigate: (page: string) => void;
}
export function Layout({
  children,
  currentPage,
  onNavigate
}: LayoutProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navItems = [{
    id: 'home',
    label: 'Beranda'
  }, {
    id: 'profil',
    label: 'Profil'
  }, {
    id: 'layanan',
    label: 'Layanan'
  }, {
    id: 'tata-kelola',
    label: 'Tata Kelola'
  }, {
    id: 'proyek',
    label: 'Proyek'
  }, {
    id: 'keterbukaan',
    label: 'Keterbukaan Informasi',
    special: true
  }, {
    id: 'kontak',
    label: 'Kontak'
  }];
  const handleNavClick = (pageId: string) => {
    onNavigate(pageId);
    setIsMobileMenuOpen(false);
  };
  const handleDownloadCompanyProfile = () => {
    window.open('https://drive.google.com/file/d/1uTnFz_7YzLi1HhnoG9POlSh5stVvcW9A/view?usp=sharing', '_blank');
  };
  return <div className="min-h-screen flex flex-col bg-wkm-slate-50 font-sans text-wkm-slate-900" data-id="element-53">
      <div className="bg-wkm-navy-900 text-wkm-slate-300 text-xs py-2.5 px-4 hidden md:block border-b border-wkm-gold-500/20" data-id="element-54">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-55">
          <div className="flex items-center space-x-6" data-id="element-56">
            <span className="flex items-center hover:text-wkm-gold-400 transition-colors" data-id="element-57">
              <Phone className="w-3 h-3 mr-2" data-id="element-58" /> (021) 5553 1569
            </span>
            <span className="flex items-center hover:text-wkm-gold-400 transition-colors" data-id="element-59">
              <Mail className="w-3 h-3 mr-2" data-id="element-60" /> info@wkmkonstruksi.id
            </span>
          </div>
          <div className="flex items-center space-x-4" data-id="element-61">
            <button onClick={handleDownloadCompanyProfile} className="flex items-center text-wkm-gold-400 hover:text-wkm-gold-300 transition-colors font-medium" data-id="element-62">
              <Download className="w-3 h-3 mr-1.5" data-id="element-63" />
              Download Company Profile
            </button>
            <span className="text-wkm-navy-600" data-id="element-64">|</span>
            <span className="text-wkm-slate-400" data-id="element-65">
              Official Corporate Website
            </span>
            <div className="flex items-center space-x-2 border-l border-wkm-navy-700 pl-4" data-id="element-66">
              <span className="text-white font-medium" data-id="element-67">ID</span>
              <span className="text-wkm-navy-600" data-id="element-68">|</span>
              <span className="hover:text-white cursor-pointer transition-colors" data-id="element-69">
                EN
              </span>
            </div>
          </div>
        </div>
      </div>

      <header className="bg-white border-b border-wkm-slate-200 sticky top-0 z-50 shadow-sm" data-id="element-70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-71">
          <div className="flex justify-between h-20" data-id="element-72">
            <div className="flex items-center cursor-pointer" onClick={() => handleNavClick('home')} data-id="element-73">
              <img src="https://cdn.magicpatterns.com/uploads/6iFxGnKDo7eRn71KoTcRtd/Company_Profile_PT_Wahana_Konstruksi_Mandiri-6.png" alt="PT Wahana Konstruksi Mandiri" className="h-12 w-auto" data-id="element-74" />
            </div>

            <nav className="hidden md:flex items-center space-x-1" data-id="element-75">
              {navItems.map(item => <button key={item.id} onClick={() => handleNavClick(item.id)} className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 ${item.special ? 'bg-red-50 text-red-700 hover:bg-red-100 ml-2 border border-red-200' : currentPage === item.id ? 'text-wkm-navy-700 bg-wkm-gold-50 border-b-2 border-wkm-gold-500' : 'text-wkm-slate-600 hover:text-wkm-navy-700 hover:bg-wkm-slate-50'}`} data-id="element-76">
                  {item.special && <AlertCircle className="w-4 h-4 inline-block mr-1.5 -mt-0.5" data-id="element-77" />}
                  {item.label}
                </button>)}
              <button onClick={handleDownloadCompanyProfile} className="ml-3 px-5 py-2 bg-wkm-gold-500 text-wkm-navy-900 rounded-md text-sm font-semibold hover:bg-wkm-gold-600 transition-all duration-200 flex items-center shadow-sm hover:shadow-md" data-id="element-78">
                <Download className="w-4 h-4 mr-2" data-id="element-79" />
                Company Profile
              </button>
            </nav>

            <div className="flex items-center md:hidden" data-id="element-80">
              <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="p-2 rounded-md text-wkm-slate-400 hover:text-wkm-slate-500 hover:bg-wkm-slate-100" data-id="element-81">
                {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-82" /> : <Menu className="w-6 h-6" data-id="element-83" />}
              </button>
            </div>
          </div>
        </div>

        {isMobileMenuOpen && <div className="md:hidden bg-white border-t border-wkm-slate-200" data-id="element-84">
            <div className="px-2 pt-2 pb-3 space-y-1" data-id="element-85">
              {navItems.map(item => <button key={item.id} onClick={() => handleNavClick(item.id)} className={`block w-full text-left px-3 py-2 rounded-md text-base font-medium ${item.special ? 'bg-red-50 text-red-700' : currentPage === item.id ? 'bg-wkm-gold-50 text-wkm-navy-700' : 'text-wkm-slate-600 hover:bg-wkm-slate-50 hover:text-wkm-navy-700'}`} data-id="element-86">
                  {item.label}
                </button>)}
              <button onClick={handleDownloadCompanyProfile} className="block w-full text-left px-3 py-2 bg-wkm-gold-500 text-wkm-navy-900 rounded-md text-base font-semibold" data-id="element-87">
                <Download className="w-4 h-4 inline-block mr-2" data-id="element-88" />
                Download Company Profile
              </button>
            </div>
          </div>}
      </header>

      <main className="flex-grow" data-id="element-89">{children}</main>

      <footer className="bg-wkm-navy-900 text-wkm-slate-300 pt-16 pb-8 border-t-4 border-wkm-gold-500" data-id="element-90">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-92">
            <div data-id="element-93">
              <img src="https://cdn.magicpatterns.com/uploads/6iFxGnKDo7eRn71KoTcRtd/Company_Profile_PT_Wahana_Konstruksi_Mandiri-6.png" alt="PT Wahana Konstruksi Mandiri" className="h-10 w-auto mb-6 brightness-0 invert" data-id="element-94" />
              <p className="text-sm text-wkm-slate-400 mb-6 leading-relaxed" data-id="element-95">
                Perusahaan konstruksi terpercaya yang berkomitmen pada kualitas,
                integritas, dan inovasi berkelanjutan.
              </p>
              <div className="flex space-x-4" data-id="element-96">
                <a href="https://instagram.com/wahana.konstruksimandiri" target="_blank" rel="noopener noreferrer" className="text-wkm-slate-400 hover:text-wkm-gold-400 transition-colors" aria-label="Instagram" data-id="element-97">
                  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-98">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" data-id="element-99" />
                  </svg>
                </a>
              </div>
            </div>

            <div data-id="element-100">
              <h4 className="text-white font-semibold mb-6 text-sm uppercase tracking-wide" data-id="element-101">
                Kantor Pusat
              </h4>
              <div className="space-y-4 text-sm" data-id="element-102">
                <div className="flex items-start" data-id="element-103">
                  <MapPin className="w-5 h-5 mr-3 text-wkm-gold-500 flex-shrink-0 mt-0.5" data-id="element-104" />
                  <span data-id="element-105">
                    Jl. Kodeco KM 2 Ruko Jhonlin Indah Blok B No. 09, Desa/Kel.
                    Sari Gadung, Kec. Simpang Empat, Kab. Tanah Bumbu,
                    Kalimantan Selatan 72213
                  </span>
                </div>
                <div className="flex items-center hover:text-wkm-gold-400 transition-colors" data-id="element-106">
                  <Phone className="w-5 h-5 mr-3 text-wkm-gold-500 flex-shrink-0" data-id="element-107" />
                  <a href="tel:02155531569" data-id="element-108">(021) 5553 1569</a>
                </div>
                <div className="flex items-center hover:text-wkm-gold-400 transition-colors" data-id="element-109">
                  <Mail className="w-5 h-5 mr-3 text-wkm-gold-500 flex-shrink-0" data-id="element-110" />
                  <a href="mailto:info@wkmkonstruksi.id" data-id="element-111">
                    info@wkmkonstruksi.id
                  </a>
                </div>
              </div>
            </div>

            <div data-id="element-112">
              <h4 className="text-white font-semibold mb-6 text-sm uppercase tracking-wide" data-id="element-113">
                Kantor Cabang
              </h4>
              <div className="space-y-4 text-sm" data-id="element-114">
                <div className="flex items-start" data-id="element-115">
                  <MapPin className="w-5 h-5 mr-3 text-wkm-gold-500 flex-shrink-0 mt-0.5" data-id="element-116" />
                  <span data-id="element-117">
                    Jl. Mangkupalas Business Center, Desa/Kel. Simpang Pasir,
                    Kec. Palaran, Kota Samarinda, Kalimantan Timur 75251
                  </span>
                </div>
              </div>
            </div>

            <div data-id="element-118">
              <h4 className="text-white font-semibold mb-6 text-sm uppercase tracking-wide" data-id="element-119">
                Tautan Cepat
              </h4>
              <ul className="space-y-3 text-sm" data-id="element-120">
                <li data-id="element-121">
                  <button onClick={() => onNavigate('keterbukaan')} className="hover:text-wkm-gold-400 transition-colors" data-id="element-122">
                    Keterbukaan Informasi
                  </button>
                </li>
                <li data-id="element-123">
                  <button onClick={() => onNavigate('tata-kelola')} className="hover:text-wkm-gold-400 transition-colors" data-id="element-124">
                    Corporate Secretary
                  </button>
                </li>
                <li data-id="element-125">
                  <button onClick={() => onNavigate('tata-kelola')} className="hover:text-wkm-gold-400 transition-colors" data-id="element-126">
                    Struktur Organisasi
                  </button>
                </li>
                <li data-id="element-127">
                  <button onClick={() => onNavigate('proyek')} className="hover:text-wkm-gold-400 transition-colors" data-id="element-128">
                    Portofolio Proyek
                  </button>
                </li>
                <li data-id="element-129">
                  <button onClick={handleDownloadCompanyProfile} className="hover:text-wkm-gold-400 transition-colors flex items-center" data-id="element-130">
                    <Download className="w-4 h-4 mr-2" data-id="element-131" /> Company Profile PDF
                  </button>
                </li>
                <li data-id="element-132">
                  <button onClick={() => onNavigate('keterbukaan')} className="hover:text-wkm-gold-400 transition-colors flex items-center" data-id="element-133">
                    <Download className="w-4 h-4 mr-2" data-id="element-134" /> Download Center
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-wkm-navy-800 pt-8 mt-8 flex flex-col md:flex-row justify-between items-center text-sm text-wkm-slate-500" data-id="element-135">
            <p data-id="element-136">
              &copy; {new Date().getFullYear()} PT Wahana Konstruksi Mandiri.
              All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-137">
              <span className="block max-w-md text-xs text-right" data-id="element-138">
                Disclaimer: Informasi pada website ini diperbarui secara berkala
                untuk kepentingan keterbukaan informasi publik dan kepatuhan
                regulator.
              </span>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}